import { DoqType, DoqWithSideContent } from '@ardoq/doq';
import { EmptyStatesDoqContainer } from '@ardoq/graph';
import { t, type I18nLocale } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { connect } from '@ardoq/rxbeach';
import { map } from 'rxjs';

type CanvasEmptyStateProps = {
  isCanvasEmpty: boolean;
  isCanvasNoSelection: boolean;
  i18nLocale: I18nLocale;
};

const CanvasEmptyState = ({
  isCanvasEmpty,
  isCanvasNoSelection,
  i18nLocale,
}: CanvasEmptyStateProps) => {
  if (isCanvasEmpty) {
    return (
      <EmptyStatesDoqContainer>
        <DoqWithSideContent
          doqType={DoqType.ALGORITHM}
          title={t(
            i18nLocale,
            'tabview:blockDiagram.canvasEmptyState.nothingToSeeTitle',
            'Nothing to see here'
          )}
          message={t(
            i18nLocale,
            'tabview:blockDiagram.canvasEmptyState.nothingToSeeMessage',
            'Your selections resulted in no data. This is likely due to filters or required paths.'
          )}
        />
      </EmptyStatesDoqContainer>
    );
  }
  if (isCanvasNoSelection) {
    return (
      <EmptyStatesDoqContainer>
        <DoqWithSideContent
          doqType={DoqType.CHOOSE_ORG}
          title={t(
            i18nLocale,
            'tabview:blockDiagram.canvasEmptyState.nothingOpenedTitle',
            'Nothing opened yet'
          )}
          message={t(
            i18nLocale,
            'tabview:blockDiagram.canvasEmptyState.nothingOpenedMessage',
            'Select one or more component(s) in the navigator to the left to get started.'
          )}
        />
      </EmptyStatesDoqContainer>
    );
  }
};

export const CanvasEmptyStates = connect(
  CanvasEmptyState,
  i18nLocale$.pipe(map(i18nLocale => ({ i18nLocale })))
);
